import * as React from "react";

interface GenPanelSliceProps {
  children: React.ReactNode;
}

export default function GenPanelSlice(
  {
    children,
  }: GenPanelSliceProps,
) {
  return (
    <div className="gen-panel-slice">
      {children}
    </div>
  );
}
